import { Typography, styled } from "@material-ui/core";

export const SummaryContentText = styled(Typography)({
  color: "#0C172C",
  fontFamily: "'Inter', 'sans-serif'",
  fontSize: "14px",
  fontWeight: 600,
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  // Dark mode (additive): only applies under the `.dark` root; light unchanged.
  ".dark &": {
    color: "hsl(var(--sds-foreground))",
  },
});
